import Datagent                              from 'datagent';
import {respondData, requestHandle, setYear, List} from '../utils';
import Fecha                                 from '../utils/type/Fecha';
import Schema                            from 'datagent/src/classes/Schema.class';
import {defaults}                            from 'datagent/src/utils';
import DimensionSchema from "./schema/Dimension.schema"

const {filter, format, getField, awaitTo} = Datagent.Hooks;

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

export const Dimension = val=>DimensionSchema.format(val)

//公司定义（舆情内容限定）
export const companySchema = new Schema({
  'abbreviation': {type: String, default: ""}, //公司简称
  'companyName': {type: String, default: ""}, //公司全称
})
export const Company = val=>companySchema.format(val)

const name  = 'listedPunishment';
const Model = Datagent.Model({
    name,
    fields : {
        'title'             : {type: String, default: ''}, // 标题
        'oid'               : {type: Number, default: ''}, // 舆情数据唯一标识
        'companyInfo'       : {type: Company, default: companySchema.default()}, // 公司信息
        'stockCode'         : {type: String, default: ''}, // 股票代码
        'postTime'          : {type: Fecha, default: ''}, // 发布时间
        'sentiment_new'     : {type: String, default: ''}, // 情感
        'source'            : {type: String, default: ''}, // 舆情来源
        'secondTargetNum'   : {type: String, default: ''}, // 二级指标编号，若为待定时返回""
        'secondTargetName'  : {type: String, default: ''}, // 二级指标名称
        'thirdTargetNum'    : {type: String, default: ''}, // 三级指标编号，若为待定时返回""
        'thirdTargetName'   : {type: String, default: ''}, // 三级指标名称
        'title'             : {type: String, default: ''}, // 舆情标题
        'url'               : {type: String, default: ''}, // 原文链接
        'keywords'          : {type: String, default: ''}, // 命中关键词
        'negativeSection'   : {type: String, default: ''}, // 命中内容
        'score'             : {type: Fecha, default: ''}, // 得分
        'is_confirm'        : {type: Number, default: 0}, //确认标记0-待确认；1-已收录；2-已排除
        'audit'             : {type: Number, default: 0}, //审核标记：0-""；1-待审核；2-不通过；3-通过
        'comment'           : {type: String, default: ''}, //审核评论
        'dimensionInfo'     : {type: List(Dimension), default: []}, //维度指标信息
    },
    methods: {
        /**
         * 上市舆情趋势图
         *
         * @param {*} params
         * @param {string[]} params.industryIdList 行业列表,例: ["1","2"]
         * @param {string[]} params.timeScope 发布时间范围,例: ["2020-09-01", "2020-09-02"]
         * @param {string} params.method 统计方式 0-求和（默认）；1-求平均值
         * @param {*} opts
         * @returns
         */
        tendency (params, opts) {
          const {origin} = defaults(opts);
          return this.remote(origin).get(`${this._url}/tendency/`, params)
        },
        /**
         * 修改舆情指标
         * （只修改三级指标时使用）
         *
         * @param {*} params
         * @param {string} params.thirdTargetNum 三级指标
         * @param {*} opts
         * @returns
         */
        thirdTargetNum (params, opts) {
          const {origin} = defaults(opts);
          return this.remote(origin).put(`${this._url}/`, params)
        },
        /**
         * 修改上市公司处罚详情
         *
         * @param {*} params
         * @param {number} params.is_confirm 0-未确认（默认）；1-收录；2-排除
         * @param {*} opts
         * @returns
         */
        saveDetail (params, opts) {
          const {origin} = defaults(opts);
          return this.remote(origin).put(`${this._url}/detail`, params)
        },
        /**
         * 修改舆情的维度评分
         *
         * @param {*} params
         * @param {dimensionSchema[]} params.dimensionInfo
         * @param {*} opts
         * @returns
         */
        dimension (params, opts) {
          const {origin} = defaults(opts);
          return this.remote(origin).put(`${this._url}/dimension`, params)
        },

        /**
         * 上市公司处罚列表导出
         *
         * @param {*} params
         * @param {number} params.offset 分页偏移值
         * @param {number} params.limit 每页显示数量
         * @param {string[]} params.timeScope 发布时间范围,例: ["2020-09-01", "2020-09-02"]
         * @param {string[]} params.punishmentNumber 处罚文书号（支持模糊查询）
         * @param {string[]} params.punishContent 处罚正文（支持模糊查询）
         * @param {number} params.industryId 行业id
         * @param {string} params.stockCode 股票代码
         * @param {number} params.scoreTag 评分筛选 0-未评分；1-已评分
         * @param {number} params.audit 审核状态筛选 1-待审核；2-不通过；3-通过
         * @param {string} params.firstTargetNum 一级指标编号筛选
         * @param {string} params.secondTargetNum 二级指标编号筛选
         * @param {string} params.thirdTargetNum 三级指标编号筛选
         * @param {*} opts
         * @returns
         */
        Export(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/export`, params)
        },
        company(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).put(`${this._url}/company`, params)
        },
        /**
         * 修改标题
         *
         * @param {*} params
         * @param {string} params.title 新标题
         * @param {*} opts
         * @returns
         */
        title (params, opts) {
          const {origin} = defaults(opts);
          return this.remote(origin).put(`${this._url}/title`, params)
        },
        qySnapshot (params, opts) {
          if(typeof params.id =="undefined") throw new Error("The params id is required in qySnapshot")
          const {origin} = defaults(opts);
          return this.remote(origin).get(`${this._url}/qySnapshot`, params)
        },
    },
    hooks  : {
        ...Datagent.mapSendHook([format()]),
        fetch              : {after: [respondData(), requestHandle(), getField('data', format()), setYear()]},
        SearchPublicSentiment : {after: [respondData(), requestHandle(), getField('data', format())]},
        find               : {after: [respondData(), requestHandle(), format()]},
        monthSentiment : {after: [respondData(), requestHandle()]},
        exportPublicSentiment : {after: [respondData(), requestHandle()]},
        exportMonthSentiment : {after: [respondData(), requestHandle()]},
        thirdTargetNum : {after: [respondData(), requestHandle()]},
        data : {after: [respondData(), requestHandle()]},
        Export : {after: [respondData(), requestHandle()]},
        tendency : {after: [respondData(), requestHandle()]},
        company : {after: [respondData(), requestHandle()]},
        destroy : {after: [respondData(), requestHandle()]},
        qySnapshot : {after: [respondData(), requestHandle()]}
    }
});

Model.ModelName   = name;
export default Model;
